import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App';
import { AppProviders } from '../providers/AppProviders';

export function renderApp(rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <AppProviders>
      <App />
    </AppProviders>
  );

  return root;
}
